module.exports = __webpack_public_path__ + "img/icon-filter.eebf5067.svg";